import { createAction } from '@reduxjs/toolkit';
import { getPayloadCreator } from '../core/actionHelpers';
import type { QcsSyncResourcesPayload } from '../core/resourceStoreTypes';
import type { ReportConfiguration, ReportConfigurationProps } from './reportConfigurationsTypes';

export type REPORT_CONFIGURATIONS_RESOURCE_PAYLOAD = ReportConfiguration;
export type REPORT_CONFIGURATIONS_RESOURCES_PAYLOAD = ReportConfiguration[];
export type REPORT_CONFIGURATIONS_ERROR_PAYLOAD = { id?: string; message?: string }; // Error object spread onto payload, could be anything

export const getReportConfigurations = createAction('GET_REPORT_CONFIGURATIONS', getPayloadCreator());

export const getReportConfigurationsSuccess = createAction(
  'GET_REPORT_CONFIGURATIONS_SUCCESS',
  getPayloadCreator<QcsSyncResourcesPayload<ReportConfigurationProps>>(),
);

export const getReportConfigurationsFailure = createAction(
  'GET_REPORT_CONFIGURATIONS_FAILURE',
  getPayloadCreator<REPORT_CONFIGURATIONS_ERROR_PAYLOAD>(),
);

export const createReportConfiguration = createAction(
  'CREATE_REPORT_CONFIGURATION',
  getPayloadCreator<REPORT_CONFIGURATIONS_RESOURCE_PAYLOAD>(),
);

export const createReportConfigurationSuccess = createAction(
  'CREATE_REPORT_CONFIGURATION_SUCCESS',
  getPayloadCreator<REPORT_CONFIGURATIONS_RESOURCE_PAYLOAD>(),
);

export const createReportConfigurationFailure = createAction(
  'CREATE_REPORT_CONFIGURATION_FAILURE',
  getPayloadCreator<REPORT_CONFIGURATIONS_ERROR_PAYLOAD>(),
);

export const updateReportConfiguration = createAction(
  'UPDATE_REPORT_CONFIGURATION',
  getPayloadCreator<REPORT_CONFIGURATIONS_RESOURCE_PAYLOAD>(),
);

export const updateReportConfigurationSuccess = createAction(
  'UPDATE_REPORT_CONFIGURATION_SUCCESS',
  getPayloadCreator<REPORT_CONFIGURATIONS_RESOURCE_PAYLOAD>(),
);

export const updateReportConfigurationFailure = createAction(
  'UPDATE_REPORT_CONFIGURATION_FAILURE',
  getPayloadCreator<REPORT_CONFIGURATIONS_ERROR_PAYLOAD>(),
);

export const deleteReportConfiguration = createAction(
  'DELETE_REPORT_CONFIGURATION',
  getPayloadCreator<REPORT_CONFIGURATIONS_RESOURCE_PAYLOAD>(),
);

export const deleteReportConfigurationSuccess = createAction(
  'DELETE_REPORT_CONFIGURATION_SUCCESS',
  getPayloadCreator<REPORT_CONFIGURATIONS_RESOURCE_PAYLOAD>(),
);

export const deleteReportConfigurationFailure = createAction(
  'DELETE_REPORT_CONFIGURATION_FAILURE',
  getPayloadCreator<REPORT_CONFIGURATIONS_ERROR_PAYLOAD>(),
);

export const batchReportConfigurations = createAction(
  'BATCH_REPORT_CONFIGURATIONS',
  getPayloadCreator<REPORT_CONFIGURATIONS_RESOURCES_PAYLOAD>(),
);

export const batchReportConfigurationsSuccess = createAction(
  'BATCH_REPORT_CONFIGURATIONS_SUCCESS',
  getPayloadCreator<REPORT_CONFIGURATIONS_RESOURCES_PAYLOAD>(),
);

export const batchReportConfigurationsFailure = createAction(
  'BATCH_REPORT_CONFIGURATIONS_FAILURE',
  getPayloadCreator<REPORT_CONFIGURATIONS_RESOURCES_PAYLOAD>(),
);
